// Central data-testid registry for WeAutomate frontend.

export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  oem: "nav-oem",
  homeAutomation: "nav-home-automation",
  industrial: "nav-industrial",
  marketplace: "nav-marketplace",
  platforms: "nav-platforms",
  opportunities: "nav-opportunities",
  investors: "nav-investors",
  founders: "nav-founders",
  blog: "nav-blog",
  contact: "nav-contact",
  login: "nav-login",
  register: "nav-register",
  dashboard: "nav-dashboard",
  logout: "nav-logout",
  themeToggle: "nav-theme-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HOME = {
  heroHeadline: "home-hero-headline",
  heroCtaQuote: "home-hero-cta-quote",
  heroCtaMarketplace: "home-hero-cta-marketplace",
  pillarOem: "home-pillar-oem",
  pillarHome: "home-pillar-home-auto",
  pillarIndustrial: "home-pillar-industrial",
  marketplacePreview: "home-marketplace-preview",
};

export const AUTH = {
  loginEmail: "auth-login-email",
  loginPassword: "auth-login-password",
  loginSubmit: "auth-login-submit",
  loginError: "auth-login-error",
  registerName: "auth-register-name",
  registerEmail: "auth-register-email",
  registerPassword: "auth-register-password",
  registerPhone: "auth-register-phone",
  registerRole: "auth-register-role",
  registerSubmit: "auth-register-submit",
};

export const MARKETPLACE = {
  grid: "marketplace-grid",
  categoryFilter: "marketplace-category-filter",
  productCard: (slug) => `product-card-${slug}`,
  addToCart: (slug) => `add-to-cart-${slug}`,
  buyNow: (slug) => `buy-now-${slug}`,
  cartIcon: "cart-icon",
  cartCount: "cart-count",
};

export const PRODUCT = {
  title: "product-title",
  price: "product-price",
  qtyInput: "product-qty",
  addToCart: "product-add-to-cart",
  buyNow: "product-buy-now",
};

export const CART = {
  itemRow: (id) => `cart-item-${id}`,
  removeBtn: (id) => `cart-remove-${id}`,
  qtyInput: (id) => `cart-qty-${id}`,
  subtotal: "cart-subtotal",
  tax: "cart-tax",
  total: "cart-total",
  affiliateCode: "cart-affiliate-code",
  applyAffiliate: "cart-apply-affiliate",
  checkoutBtn: "cart-checkout",
};

export const CHECKOUT = {
  shippingName: "checkout-name",
  shippingPhone: "checkout-phone",
  shippingLine1: "checkout-line1",
  shippingCity: "checkout-city",
  shippingState: "checkout-state",
  shippingPincode: "checkout-pincode",
  placeOrder: "checkout-place-order",
};

export const QUOTE = {
  name: "quote-name",
  email: "quote-email",
  phone: "quote-phone",
  projectType: "quote-project-type",
  description: "quote-description",
  budget: "quote-budget",
  timeline: "quote-timeline",
  submit: "quote-submit",
};

export const APPLY = {
  type: (t) => `apply-type-${t}`,
  name: "apply-name",
  email: "apply-email",
  phone: "apply-phone",
  city: "apply-city",
  roleApplied: "apply-role",
  payload: "apply-payload",
  submit: "apply-submit",
};

export const CONTACT = {
  name: "contact-name",
  email: "contact-email",
  phone: "contact-phone",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
};

export const ADMIN = {
  sidebarUsers: "admin-side-users",
  sidebarProducts: "admin-side-products",
  sidebarOrders: "admin-side-orders",
  sidebarLeads: "admin-side-leads",
  sidebarApplications: "admin-side-applications",
  sidebarAffiliates: "admin-side-affiliates",
  sidebarVendors: "admin-side-vendors",
  sidebarTickets: "admin-side-tickets",
  sidebarCms: "admin-side-cms",
  sidebarVisibility: "admin-side-visibility",
  sidebarConfig: "admin-side-config",
  statsCard: (key) => `admin-stat-${key}`,
};

export const CHATBOT = {
  toggle: "chatbot-toggle",
  panel: "chatbot-panel",
  input: "chatbot-input",
  send: "chatbot-send",
  messages: "chatbot-messages",
};
